import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Input as BaseInput } from '@/components/Input';
import { Typography } from '@/components/Typography';

export const highlightedTagName = 'em';

import { ReactComponent as Search } from '@/assets/icons/search.svg';

export const Wrapper = styled(Box)`
  position: relative;
`;

export const InputWrapper = styled(Flex)`
  position: relative;
  align-items: center;
`;

export const Input = styled(BaseInput)`
  outline: none;
  text-overflow: ellipsis;

  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.black};
    padding: ${theme.spacing(1.25, 6, 1.25, 0)};
    font-size: ${theme.fontSizes.p2};
    line-height: 22px;

    &::placeholder {
      color: ${theme.colors.inputGrey};
    }
  `}
`;

export const Results = styled(Box)`
  position: absolute;
  width: 100%;
  text-align: left;

  ${({ theme }) => css`
    border-top: none;
    z-index: ${theme.zIndex.searchOverlay};
    background-color: ${theme.colors.white};
  `}
`;

export const GroupLabel = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.textLightGrey};
    font-size: ${theme.fontSizes.p2};
    font-weight: ${theme.fontWeights.bold};
    background-color: transparent;
    padding: ${theme.spacing(1.5, 2)};
    margin-top: ${theme.spacing(1)};
    line-height: ${theme.spacing(2.5)};
    font-family: ${theme.fontFamilies.openSans};
    text-transform: uppercase;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: ${theme.spacing(2)};
      right: ${theme.spacing(2)};
      bottom: 0;
      height: 1px;
      background-color: ${theme.colors.mediumGrey};
    }
  `}
`;

export const Separator = styled.hr`
  border: none;
  margin: 0;
`;

export const Result = styled(Typography)`
  display: block;
  cursor: pointer;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p1};
    font-family: ${theme.fontFamilies.openSans};
    padding: ${theme.spacing(1, 2)};

    ${highlightedTagName} {
      font-weight: ${theme.fontWeights.bold};
      background-color: ${theme.colors.white};
    }
  `}
`;

export const SearchIcon = styled(Search)`
  position: absolute;
  right: 0;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 1;
  margin: ${({ theme }) => theme.spacing(2, 0, 2, 2)};
`;
